// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CookiesDisclaimer-space1-CLPes {
	margin-bottom: 6px !important;
}

.CookiesDisclaimer-space2-nZpBv {
	margin-bottom: 12px !important;
}

.CookiesDisclaimer-space3-JyD3S {
	margin-bottom: 18px !important;
}

.CookiesDisclaimer-space4-Mt_s8 {
	margin-bottom: 24px !important;
}

.CookiesDisclaimer-space5-DWpbX {
	margin-bottom: 30px !important;
}

.CookiesDisclaimer-space6-qWr0J {
	margin-bottom: 36px !important;
}

.CookiesDisclaimer-space7-J94uB {
	margin-bottom: 42px !important;
}

.CookiesDisclaimer-spaceTop8-K8uEg {
	margin-bottom: 48px !important;
}

.CookiesDisclaimer-spaceTop1-wR59g {
	margin-top: 6px !important;
}

.CookiesDisclaimer-spaceTop2-gdxZf {
	margin-top: 12px !important;
}

.CookiesDisclaimer-spaceTop3-pdU_Y {
	margin-top: 18px !important;
}

.CookiesDisclaimer-spaceTop4-HaE__ {
	margin-top: 24px !important;
}

.CookiesDisclaimer-spaceTop5-jxqKL {
	margin-top: 30px !important;
}

.CookiesDisclaimer-spaceTop6-ABrIn {
	margin-top: 36px !important;
}

.CookiesDisclaimer-spaceTop7-P43XW {
	margin-top: 42px !important;
}

.CookiesDisclaimer-spaceTop8-K8uEg {
	margin-top: 48px !important;
}

.CookiesDisclaimer-noMargin-JA7Lh {
	margin: 0px !important;
}

.CookiesDisclaimer-padding1-mHKqx {
	padding-bottom: 6px !important;
}

.CookiesDisclaimer-padding2-OcXP0 {
	padding-bottom: 12px !important;
}

.CookiesDisclaimer-padding3-YlzfT {
	padding-bottom: 18px !important;
}

.CookiesDisclaimer-padding4-EEQjZ {
	padding-bottom: 24px !important;
}

.CookiesDisclaimer-padding5-wozOm {
	padding-bottom: 30px !important;
}

.CookiesDisclaimer-padding6-S4J05 {
	padding-bottom: 36px !important;
}

.CookiesDisclaimer-padding7-LYRL6 {
	padding-bottom: 42px !important;
}

.CookiesDisclaimer-paddingTop1-LKpoP {
	padding-top: 6px !important;
}

.CookiesDisclaimer-paddingTop2-Mv6fa {
	padding-top: 12px !important;
}

.CookiesDisclaimer-paddingTop3-v1a21 {
	padding-top: 18px !important;
}

.CookiesDisclaimer-paddingTop4-hqowK {
	padding-top: 24px !important;
}

.CookiesDisclaimer-paddingTop5-oVVZ5 {
	padding-top: 30px !important;
}

.CookiesDisclaimer-paddingTop6-k5OfK {
	padding-top: 36px !important;
}

.CookiesDisclaimer-paddingTop7-HuDcq {
	padding-top: 42px !important;
}

.CookiesDisclaimer-noPadding-X1tzc {
	padding: 0px !important;
}

.CookiesDisclaimer-textBold-NeuVT {
	font-weight: 500 !important;
}

.CookiesDisclaimer-textBolder-U1NV0 {
	font-weight: 700 !important;
}

.CookiesDisclaimer-textNormal-Wq4Wu {
	font-weight: normal !important;
}

.CookiesDisclaimer-spaceBottom20-dv32q {
	margin-bottom: 20px;
}

.CookiesDisclaimer-spaceBottom10-XrC5z {
	margin-bottom: 10px;
}

.CookiesDisclaimer-marginNone-gYqNf {
	margin: 0;
}

.CookiesDisclaimer-spaceBottom15-wsiT2 {
	margin-bottom: 15px;
}

.CookiesDisclaimer-marginTopNone-ijgUE {
	margin-top: 0;
}

.CookiesDisclaimer-spaceTop11-Lh5be {
	margin-top: 11px;
}

.CookiesDisclaimer-spaceTop21-TfwGT {
	margin-top: 21px;
}

.CookiesDisclaimer-spaceTop20-fOR6Q {
	margin-top: 20px;
}

.CookiesDisclaimer-spaceTop10-fwQ2_ {
	margin-top: 10px;
}

/*New Design Text Colors */

.CookiesDisclaimer-textDarkBlue-DeMEC {
	color: rgb(20, 39, 94) !important;
}

.CookiesDisclaimer-textLightBlue-HoEEc {
	color: rgb(57, 87, 106) !important;
}

.CookiesDisclaimer-textLightSandleGreen-JK6IH {
	color: rgb(76, 86, 41) !important;
}

.CookiesDisclaimer-textLightBrown-RlqMP {
	color: rgb(115, 79, 33) !important;
}

.CookiesDisclaimer-textMediumMaroon-dWi73 {
	color: rgb(87, 37, 51) !important;
}

.CookiesDisclaimer-textBrown-oorqT {
	color: rgb(160, 47, 24) !important;
}

.CookiesDisclaimer-textMaroon-Pb59g {
	color: rgb(155, 49, 67) !important;
}

.CookiesDisclaimer-textDarkBrown-xqWG4 {
	color: rgb(83, 18, 16) !important;
}

.CookiesDisclaimer-textMediumBrown-_TqIz {
	color: rgb(142, 28, 10) !important;
}

.CookiesDisclaimer-textSkyBlue-H5qGG {
	color: rgb(37, 117, 141) !important;
}

.CookiesDisclaimer-textGray-BF14v {
	color: rgb(77, 65, 51) !important;
}

.CookiesDisclaimer-cookiesBackground-P4pC2 {
	background-color: var(--background-primary) !important;
	border-radius: 4px;
	-webkit-box-shadow: 0 1px 10px 0px var(--primary-box-shadow);
	        box-shadow: 0 1px 10px 0px var(--primary-box-shadow);
}

.CookiesDisclaimer-root-t3opH {
	padding: 10px;
}

.CookiesDisclaimer-labelText-cAfUQ {
	font-size: 16px;
	font-weight: 600;
	line-height: normal;
	color: var(--primary-foreground);
}

.CookiesDisclaimer-linkStyle-USfHQ {
	color: var(--primary-foreground) !important;
	font-style: italic;
	font-weight: bold;
	text-decoration: underline;
}

.CookiesDisclaimer-button-sbqg1 {
	font-weight: 700;
	margin-top: 0px;
	float: right;
	z-index: 9;
	font-size: 18px;
	min-width: 140px;
}

.CookiesDisclaimer-fixedPosition-OKfG9 {
	position: fixed !important;
	right: 0px;
	bottom: 0px;
	left: 0px;
	z-index: 1005;
}

.CookiesDisclaimer-displayTable-s367o {
	width: 100%;
	display: table;
}

.CookiesDisclaimer-displayRow-pWJj7 {
	width: 100%;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	gap: 30px;
}

.CookiesDisclaimer-displayText-u7vsj {
	display: table-cell;
	width: 90%;
	vertical-align: middle;
}

.CookiesDisclaimer-displayBtn-3BQZA {
	width: 10%;
	display: table-cell;
	vertical-align: middle;
}

.CookiesDisclaimer-displayTableSection-qKmDt {
	padding: 15px;
}

@media screen and (max-width: 1030px) {
	.CookiesDisclaimer-labelText-cAfUQ {
		font-size: 14px;
	}
}

@media screen and (max-width: 767px) {
	.CookiesDisclaimer-displayText-u7vsj {
		display: block;
		width: 100%;
	}

	.CookiesDisclaimer-displayBtn-3BQZA {
		width: 100%;
		display: block;
		margin-top: 12px;
	}

	.CookiesDisclaimer-button-sbqg1 {
		margin-top: 8px;
	}

	.CookiesDisclaimer-displayTableSection-qKmDt {
		padding: 15px;
	}
}

@media screen and (max-width: 480px) {
	.CookiesDisclaimer-cookiesBackground-P4pC2 {
		height: auto;
	}

	.CookiesDisclaimer-button-sbqg1 {
		float: right;
		margin-top: 0px;
		margin-bottom: 10px;
		font-size: 15px;
		font-weight: 300;
	}

	.CookiesDisclaimer-labelText-cAfUQ {
		font-size: 15px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/CookiesDisclaimer/CookiesDisclaimer.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,sDAAsD;CACtD,kBAAkB;CAClB,4DAAoD;SAApD,oDAAoD;AACrD;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,iBAAiB;CACjB,0BAA0B;AAC3B;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,YAAY;CACZ,UAAU;CACV,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;CAC1B,UAAU;CACV,WAAW;CACX,SAAS;CACT,aAAa;AACd;;AAEA;CACC,WAAW;CACX,cAAc;AACf;;AAEA;CACC,WAAW;CACX,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,SAAS;AACV;;AAEA;CACC,mBAAmB;CACnB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,UAAU;CACV,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,aAAa;AACd;;AAGA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC,cAAc;EACd,WAAW;CACZ;;CAEA;EACC,WAAW;EACX,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,eAAe;CAChB;AACD","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../helpers.css';\n\n.cookiesBackground {\n\tbackground-color: var(--background-primary) !important;\n\tborder-radius: 4px;\n\tbox-shadow: 0 1px 10px 0px var(--primary-box-shadow);\n}\n\n.root {\n\tpadding: 10px;\n}\n\n.labelText {\n\tfont-size: 16px;\n\tfont-weight: 600;\n\tline-height: normal;\n\tcolor: var(--primary-foreground);\n}\n\n.linkStyle {\n\tcolor: var(--primary-foreground) !important;\n\tfont-style: italic;\n\tfont-weight: bold;\n\ttext-decoration: underline;\n}\n\n.button {\n\tfont-weight: 700;\n\tmargin-top: 0px;\n\tfloat: right;\n\tz-index: 9;\n\tfont-size: 18px;\n\tmin-width: 140px;\n}\n\n.fixedPosition {\n\tposition: fixed !important;\n\tright: 0px;\n\tbottom: 0px;\n\tleft: 0px;\n\tz-index: 1005;\n}\n\n.displayTable {\n\twidth: 100%;\n\tdisplay: table;\n}\n\n.displayRow {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tgap: 30px;\n}\n\n.displayText {\n\tdisplay: table-cell;\n\twidth: 90%;\n\tvertical-align: middle;\n}\n\n.displayBtn {\n\twidth: 10%;\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n\n.displayTableSection {\n\tpadding: 15px;\n}\n\n\n@media screen and (max-width: 1030px) {\n\t.labelText {\n\t\tfont-size: 14px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.displayText {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t}\n\n\t.displayBtn {\n\t\twidth: 100%;\n\t\tdisplay: block;\n\t\tmargin-top: 12px;\n\t}\n\n\t.button {\n\t\tmargin-top: 8px;\n\t}\n\n\t.displayTableSection {\n\t\tpadding: 15px;\n\t}\n}\n\n@media screen and (max-width: 480px) {\n\t.cookiesBackground {\n\t\theight: auto;\n\t}\n\n\t.button {\n\t\tfloat: right;\n\t\tmargin-top: 0px;\n\t\tmargin-bottom: 10px;\n\t\tfont-size: 15px;\n\t\tfont-weight: 300;\n\t}\n\n\t.labelText {\n\t\tfont-size: 15px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `CookiesDisclaimer-space1-CLPes`,
	"space2": `CookiesDisclaimer-space2-nZpBv`,
	"space3": `CookiesDisclaimer-space3-JyD3S`,
	"space4": `CookiesDisclaimer-space4-Mt_s8`,
	"space5": `CookiesDisclaimer-space5-DWpbX`,
	"space6": `CookiesDisclaimer-space6-qWr0J`,
	"space7": `CookiesDisclaimer-space7-J94uB`,
	"spaceTop8": `CookiesDisclaimer-spaceTop8-K8uEg`,
	"spaceTop1": `CookiesDisclaimer-spaceTop1-wR59g`,
	"spaceTop2": `CookiesDisclaimer-spaceTop2-gdxZf`,
	"spaceTop3": `CookiesDisclaimer-spaceTop3-pdU_Y`,
	"spaceTop4": `CookiesDisclaimer-spaceTop4-HaE__`,
	"spaceTop5": `CookiesDisclaimer-spaceTop5-jxqKL`,
	"spaceTop6": `CookiesDisclaimer-spaceTop6-ABrIn`,
	"spaceTop7": `CookiesDisclaimer-spaceTop7-P43XW`,
	"noMargin": `CookiesDisclaimer-noMargin-JA7Lh`,
	"padding1": `CookiesDisclaimer-padding1-mHKqx`,
	"padding2": `CookiesDisclaimer-padding2-OcXP0`,
	"padding3": `CookiesDisclaimer-padding3-YlzfT`,
	"padding4": `CookiesDisclaimer-padding4-EEQjZ`,
	"padding5": `CookiesDisclaimer-padding5-wozOm`,
	"padding6": `CookiesDisclaimer-padding6-S4J05`,
	"padding7": `CookiesDisclaimer-padding7-LYRL6`,
	"paddingTop1": `CookiesDisclaimer-paddingTop1-LKpoP`,
	"paddingTop2": `CookiesDisclaimer-paddingTop2-Mv6fa`,
	"paddingTop3": `CookiesDisclaimer-paddingTop3-v1a21`,
	"paddingTop4": `CookiesDisclaimer-paddingTop4-hqowK`,
	"paddingTop5": `CookiesDisclaimer-paddingTop5-oVVZ5`,
	"paddingTop6": `CookiesDisclaimer-paddingTop6-k5OfK`,
	"paddingTop7": `CookiesDisclaimer-paddingTop7-HuDcq`,
	"noPadding": `CookiesDisclaimer-noPadding-X1tzc`,
	"textBold": `CookiesDisclaimer-textBold-NeuVT`,
	"textBolder": `CookiesDisclaimer-textBolder-U1NV0`,
	"textNormal": `CookiesDisclaimer-textNormal-Wq4Wu`,
	"spaceBottom20": `CookiesDisclaimer-spaceBottom20-dv32q`,
	"spaceBottom10": `CookiesDisclaimer-spaceBottom10-XrC5z`,
	"marginNone": `CookiesDisclaimer-marginNone-gYqNf`,
	"spaceBottom15": `CookiesDisclaimer-spaceBottom15-wsiT2`,
	"marginTopNone": `CookiesDisclaimer-marginTopNone-ijgUE`,
	"spaceTop11": `CookiesDisclaimer-spaceTop11-Lh5be`,
	"spaceTop21": `CookiesDisclaimer-spaceTop21-TfwGT`,
	"spaceTop20": `CookiesDisclaimer-spaceTop20-fOR6Q`,
	"spaceTop10": `CookiesDisclaimer-spaceTop10-fwQ2_`,
	"textDarkBlue": `CookiesDisclaimer-textDarkBlue-DeMEC`,
	"textLightBlue": `CookiesDisclaimer-textLightBlue-HoEEc`,
	"textLightSandleGreen": `CookiesDisclaimer-textLightSandleGreen-JK6IH`,
	"textLightBrown": `CookiesDisclaimer-textLightBrown-RlqMP`,
	"textMediumMaroon": `CookiesDisclaimer-textMediumMaroon-dWi73`,
	"textBrown": `CookiesDisclaimer-textBrown-oorqT`,
	"textMaroon": `CookiesDisclaimer-textMaroon-Pb59g`,
	"textDarkBrown": `CookiesDisclaimer-textDarkBrown-xqWG4`,
	"textMediumBrown": `CookiesDisclaimer-textMediumBrown-_TqIz`,
	"textSkyBlue": `CookiesDisclaimer-textSkyBlue-H5qGG`,
	"textGray": `CookiesDisclaimer-textGray-BF14v`,
	"cookiesBackground": `CookiesDisclaimer-cookiesBackground-P4pC2`,
	"root": `CookiesDisclaimer-root-t3opH`,
	"labelText": `CookiesDisclaimer-labelText-cAfUQ`,
	"linkStyle": `CookiesDisclaimer-linkStyle-USfHQ`,
	"button": `CookiesDisclaimer-button-sbqg1`,
	"fixedPosition": `CookiesDisclaimer-fixedPosition-OKfG9`,
	"displayTable": `CookiesDisclaimer-displayTable-s367o`,
	"displayRow": `CookiesDisclaimer-displayRow-pWJj7`,
	"displayText": `CookiesDisclaimer-displayText-u7vsj`,
	"displayBtn": `CookiesDisclaimer-displayBtn-3BQZA`,
	"displayTableSection": `CookiesDisclaimer-displayTableSection-qKmDt`
};
module.exports = ___CSS_LOADER_EXPORT___;
